import request from '@/shared/api/request';

import type { BucketFileMetadata } from '../types';

export const getMultipleBucketMetadata = (
  name: string,
  keys: string[],
): Promise<{ metadata: BucketFileMetadata }> =>
  request({
    url: `/buckets/${name}/objects/metadata/`,
    params: { keys: keys.join(',') },
  });
